'use client';

import { Locale, getLocale } from '@libs/core';
import { CrossDomainScript, OneTrustScript, OptanonScript } from './components';
import { useOneTrustParams } from './hooks';

const isLocaleUs = getLocale() === Locale['en-US'];
const oneTrustDomainScriptID = isLocaleUs
    ? process.env.NEXT_PUBLIC_ONETRUST_US_DOMAIN_SCRIPT_ID
    : process.env.NEXT_PUBLIC_ONETRUST_CA_DOMAIN_SCRIPT_ID;

const isOneTrustDisabled = process.env.NEXT_PUBLIC_DISABLE_ONETRUST === 'true';

export function OneTrustScripts({
    customerKey,
}: Readonly<{
    customerKey: string | undefined;
}>) {
    const { token } = useOneTrustParams({ customerKey });

    const isCrossDomainScriptEnabled = customerKey && oneTrustDomainScriptID && !isOneTrustDisabled;

    return (
        <>
            {isCrossDomainScriptEnabled && Boolean(token) && (
                <CrossDomainScript customerKey={customerKey} token={token} />
            )}
            <OneTrustScript scriptId={oneTrustDomainScriptID} />
            <OptanonScript />
        </>
    );
}
